import { Skeleton } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useCreateChartTheme } from '../../../../../theme';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const OPTIONS = {
  responsive: true,
  indexAxis: 'y',
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'top',
    },
  },
  scales: {
    x: {
      stacked: true,
      grid: {
        display: true, // ❌ oculta las líneas verticales
        drawBorder: true,
      },
    },
    y: {
      stacked: true,
      grid: {
        display: false, // ❌ oculta las líneas horizontales
        drawBorder: false,
      },
      ticks: {
        beginAtZero: true,
      },
    },
  },
};

export const GraficoBar = ({ labels, datasets, options, ...props }) => {
  const { chartTheme } = useCreateChartTheme({
    ...OPTIONS,
    ...options,
  });

  return (
    <>
      {labels && datasets && labels.length > 0 && datasets.length > 0 ? (
        <Bar options={chartTheme} data={{ labels, datasets }} />
      ) : (
        <Skeleton
          variant='rectangular'
          width={'100%'}
          height={'100%'}
          sx={{ borderRadius: '8px' }}
        />
      )}
    </>
  );
};
